<div class="layout-footer">
    <img src="assets/layout/images/DJ-Group-logo-1.jpg" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">DJ Group Ohio</span>
</div>
